import {useState} from "react";
import {useRpcSender} from "../RpcSender";
import {RpcState} from "../RpcState";
import {useProviderProfile} from "../../ProviderProfileProvider";
import {PublishOnKensuRequest, PublishOnKensuResponse} from "../../provider_api";

export const usePublishOnKensu = () => {
  const rpcSender = useRpcSender();
  
  const {setBusiness} = useProviderProfile()
  
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});

  const send = (request: PublishOnKensuRequest) => {
    setRpcState({state: 'pending'});
    rpcSender.send("publish_on_kensu", PublishOnKensuRequest.encode(request).finish())
        .then(bytes => {
          const response = PublishOnKensuResponse.decode(bytes);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'Error publishing changes'});
            return;
          }

          setBusiness(response.updatedBusiness);
          setRpcState({state: 'success'});
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error publishing changes'});
        });
  }

  return {send, rpcState}
};